import { Dialog, DialogContent, DialogActions, Button } from "@mui/material";
import { DialogTitleClosable } from "../../../components/DialogTitleClosable";
import { bhpButtonSx } from "../../../styles/bhpStyles";
import { useState } from "react";
import { DeviceSessionDto } from "../dtos/DeviceSessionDto";
import { formatDateTime } from "../../../utils";
import { DataGrid, GridColDef } from "@mui/x-data-grid";


type DeviceSessionsDialogProps = {

    deviceSessions: DeviceSessionDto[ ];
    dialogOpen: boolean;
    handleOk: ( ) => void;

};

const columns: GridColDef[ ] = [

    {
        field: 'mac',
        headerName: 'Device MAC',
        width: 150,
        // editable: true,
        headerAlign: 'center',
        align: 'center',
        // type: 'boolean'
    },
    
    {
        field: 'authTime',
        headerName: 'Last Auth Time',
        width: 200,
        // editable: true,
        headerAlign: 'center',
        align: 'center',
        // type: 'boolean'
        renderCell: ( params => formatDateTime( params.row.authTime ))
    },

    {
        field: 'villageCode',
        headerName: 'Last Login Village',
        width: 150,
        // editable: true,
        headerAlign: 'center',
        align: 'center',
        // type: 'boolean'
    },
    
    {
        field: 'accessPointMac',
        headerName: 'Last Login AP MAC',
        width: 150,
        // editable: true,
        headerAlign: 'center',
        align: 'center',
        // type: 'boolean'
    },

    {
        field: 'accept',
        headerName: 'Auth Accepted',
        width: 150,
        // editable: true,
        headerAlign: 'center',
        align: 'center',
        type: 'boolean'
    },

    



];


const dataGridSx = {

    cursor: 'pointer',
    '.MuiDataGrid-columnHeaderTitle': { 
        fontWeight: 'bold !important',
        overflow: 'visible !important'
    },

    '.MuiDataGrid-cell:focus': {
        outline: 'none'
    }

};


export const DeviceSessionsDialog : React.FC< DeviceSessionsDialogProps > = ( props : DeviceSessionsDialogProps ) => {

    const { dialogOpen, handleOk, deviceSessions } = props;

    const [ pageSize, setPageSize ] = useState<number>( 10 );

    const handleCloseClick = ( ) => handleOk( );

    
    const handleOkClick = ( ) => handleOk( );

    
    return(

        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '855px', maxWidth: '855px' } }}
            open={dialogOpen}>
            <DialogTitleClosable onClose={ handleCloseClick }>
                Device Sessions
            </DialogTitleClosable>

            <DialogContent dividers>
                
                <DataGrid
                    getRowId={ _ => Math.floor(Math.random() * 100_000_000) }
                    rows={ deviceSessions }
                    columns={ columns }
                    sx={{ ...dataGridSx, width: '805px', boxShadow: 5 }}
                    pageSize={ pageSize }
                    onPageSizeChange={ ( newPageSize ) => setPageSize( newPageSize ) }
                    rowsPerPageOptions={ [ 10, 50, 100 ] }
                    pagination
                    autoHeight={ true }
                />

            </DialogContent>
            <DialogActions>
                <Button onClick={ handleOkClick } sx={{ ...bhpButtonSx, width: '100px' }}>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>

    );


};